import React from 'react';
import _ from 'lodash';

import styles from './ProductsDetailsPropertyMenu.module.scss';
import { connect } from 'react-redux';
import { BaseStore } from 'src/store';
import { GlobalIcon, IconImage } from 'src/modules/global';
import {
  ProductProperties,
  displayProductsProperty,
  ProductsDetailsStore,
} from 'src/modules/products/details';
import { FormattedMessage } from 'react-intl';
import { LinkWithIcon } from 'src/modules/products/components/downloads/LinkWithIcon/LinkWithIcon';

interface ProductsDetailsPropertyMenuProps extends ProductsDetailsStore {
  dispatch: any;
  activeProductProperty: ProductProperties;
  className?: string;
}

const ProductsDetailsPropertyMenu: React.FunctionComponent<ProductsDetailsPropertyMenuProps> = (
  props: ProductsDetailsPropertyMenuProps
) => {
  //For some reason, defining mapDispatchToProps as an Object won't work as displayProductProperty will be empty. Using dispatch instead
  const {
    dispatch,
    activeProductProperty,
    isLoadingMaterials,
    materialColors,
    className = '',
  } = props;
  const detailsEnabled = !_.isEmpty(props.product?.product_details_overlay);
  const materialsEnabled = isLoadingMaterials || materialColors.length;
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.grid}>
        {!!detailsEnabled && (
          <div className={styles.gridItem}>
            <LinkWithIcon
              onClick={() => dispatch(displayProductsProperty(ProductProperties.Details))}
              icon={
                <GlobalIcon
                  className={styles.icon}
                  image={
                    activeProductProperty === ProductProperties.Colors
                      ? IconImage.Minus
                      : IconImage.Plus
                  }
                />
              }>
              <FormattedMessage id="page/products/details/details" />
            </LinkWithIcon>
          </div>
        )}
        {!!materialsEnabled && (
          <div className={styles.gridItem}>
            <LinkWithIcon
              onClick={() => dispatch(displayProductsProperty(ProductProperties.Colors))}
              icon={
                <GlobalIcon
                  className={styles.icon}
                  image={
                    activeProductProperty === ProductProperties.Colors
                      ? IconImage.Minus
                      : IconImage.Plus
                  }
                />
              }>
              <FormattedMessage id="page/products/details/colors_materials" />
            </LinkWithIcon>
          </div>
        )}
        {/*<div className={styles.gridItem}>
          <LinkWithIcon
            onClick={() => dispatch(displayProductsProperty(ProductProperties.Dimensions))}
            icon={
              <GlobalIcon
                className={styles.icon}
                image={
                  activeProductProperty === ProductProperties.Dimensions
                    ? IconImage.Minus
                    : IconImage.Plus
                }
              />
            }>
            <FormattedMessage id="page/products/details/dimensions" />
          </LinkWithIcon>
          </div>*/}
        <div className={styles.gridItem}>
          <LinkWithIcon
            onClick={() => dispatch(displayProductsProperty(ProductProperties.Downloads))}
            icon={
              <GlobalIcon
                className={styles.icon}
                image={
                  activeProductProperty === ProductProperties.Downloads
                    ? IconImage.Minus
                    : IconImage.Plus
                }
              />
            }>
            <FormattedMessage id="page/products/details/downloads" />
          </LinkWithIcon>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return { ...state.products.details };
};

//Redux state and actions
export default connect(mapStateToProps)(ProductsDetailsPropertyMenu);
